export enum NEWSLETTER_PAGE_SOURCE {
  HOMEPAGE = 'homepage',
  CATEGORY_PLP = 'category-plp',
  LANDING_PAGE = 'landing-page',
  CUSTOM_PLP = 'custom-plp',
  HUB_PAGE = 'hub-page',
  BRAND_PLP = 'brand-plp',
}
